import { APP_ID } from "../config/constants";
import { getRequest, postRequest } from "../connection/network";

const videoApi = "video";

export const listVideosService = async ({
  page,
  limit,
  text,
  videoId,
  categoryId,
  otherCategory,
}) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        data,
        meta: { thisPage, allPages },
      },
    } = await getRequest({
      token,
      query: {
        page,
        limit,
        text,
        videoId,
        appId: APP_ID,
        categoryId,
        otherCategory,
      },
      endPoint: videoApi,
    });

    return {
      data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    return { error: sError };
  }
};

export const myVideosService = async ({
  page,
  limit,
  text,
  videoId,
  categoryId,
}) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        data,
        meta: { thisPage, allPages },
      },
    } = await getRequest({
      token,
      query: {
        page,
        limit,
        text,
        videoId,
        appId: APP_ID,
        categoryId,
      },
      endPoint: videoApi,
    });

    return {
      data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    return { error: sError };
  }
};

export const listSingleVideoService = async ({ id, page, limit }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        meta: { thisPage, allPages },
        data: { comments, post },
      },
    } = await getRequest({
      token,
      query: {
        limit,
        page,
        appId: APP_ID,
      },
      endPoint: videoApi,
      params: id,
    });

    return {
      data: { post, comments },
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const createVideosService = async ({ sendData, cb }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: videoApi,
      token,
      multipart: true,
    });

    cb && cb(null);
    return {
      data,
      message,
    };
  } catch (error) {
    cb && cb(error);
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    return { error: sError };
  }
};
